<template>
  <div>
    <b-row>
      <b-col class="text-right mb-1">
        <router-link to="/promotion/add">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            pill
            class="px-3"
          >
            Tambah Promosi
          </b-button>
        </router-link>
      </b-col>
    </b-row>
    <b-card>
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->
          <span v-if="props.column.field === 'name'" class="text-nowrap">
            <span class="text-nowrap">{{ props.row.name }}</span>
          </span>

          <!-- Column: Created at -->
          <span
            v-else-if="props.column.field === 'start_date'"
            class="text-nowrap"
          >
            <span class="text-nowrap">{{ props.row.start_date }}</span>
          </span>

          <span
            v-else-if="props.column.field === 'end_date'"
            class="text-nowrap"
          >
            <span class="text-nowrap">{{ props.row.end_date }}</span>
          </span>

          <!-- Column: Status -->
          <span v-else-if="props.column.field === 'status'" class="text-nowrap">
            <b-badge :variant="statusVariant(props.row.status)">
              <span class="text-nowrap" v-if="props.row.status === 0">{{
                props.row.status_name
              }}</span>
              <span class="text-nowrap" v-else-if="props.row.status === 1">{{
                props.row.status_name
              }}</span>
              <span class="text-nowrap" v-else-if="props.row.status === 2">{{
                props.row.status_name
              }}</span>
            </b-badge>
          </span>

          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-bind:to="{ path: '/promotion/' + props.row.id }"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Detail</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="props.row.status == 1"
                  @click="actived(props.row.id, props.row.status)"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Non-Aktifkan</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="props.row.status == 0"
                  @click="actived(props.row.id, props.row.status)"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Aktifkan</span>
                </b-dropdown-item>

                <b-dropdown-item @click="destroy(props.row.id)">
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>Hapus</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> {{ meta.from }} - {{ meta.to }} </span>
              <span class="text-nowrap">&nbsp;dari {{ meta.total }} data </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="meta.total"
                :per-page="meta.per_page"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => getInquiry(value)"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </b-card>
  </div>
</template>

<script>
import {
  BForm,
  BFormFile,
  BModal,
  BButton,
  BRow,
  BCol,
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";

export default {
  components: {
    BCardActions,
    VueGoodTable,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormFile,
    BModal,
    BButton,
    BRow,
    BCol,
    BCard,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Kode Promosi",
          field: "code",
        },
        {
          label: "Tanggal Mulai",
          field: "start_at",
          width: "200px",
        },
        {
          label: "Tanggal Berakhir",
          field: "end_at",
          width: "200px",
        },
        {
          label: "Status",
          field: "status",
          width: "100px",
        },
        {
          label: "",
          field: "action",
          width: "50px",
        },
      ],
      rows: [],
      searchTerm: "",
      meta: {
        current_page: 1,
        last_page: 0,
        from: 0,
        to: 0,
        per_page: 10,
        total: 0,
      },
      permissions: [],
      errors: "",
      errMessage: "",
      file: null,
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        0: "light-dark",
        1: "light-success",
        2: "light-danger",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    this.getInquiry(1);
  },
  methods: {
    moment(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getInquiry($page) {
      this.$http
        .get("promotions?page=" + $page)
        .then((res) => {
          this.rows = res.data.data;
          // console.log(res.data.data)
          var meta = res.data.meta;
          if (meta.from != null) {
            this.meta.from = meta.from;
          }
          if (meta.to != null) {
            this.meta.to = meta.to;
          }
          this.meta.current_page = meta.current_page;
          this.meta.last_page = meta.last_page;
          this.meta.per_page = meta.per_page;
          this.meta.total = meta.total;
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Promotion",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    destroy($id) {
      this.$http
        .post("promotion/" + $id + "/delete")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: "Promosi berhasil dihapus",
              variant: "danger",
            },
          });
          this.getInquiry(this.meta.current_page);
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          console.log(errors.response);
        });
    },
    actived($id, $status) {
      this.$http
        .get("promotion/" + $id + "/actived")
        .then((response) => {
          var $text = "";
          var $variant = "";

          if ($status == 1) {
            $text = "Promosi berhasil dinon-aktifkan";
            $variant = "warning";
          } else {
            $text = "Promosi berhasil diaktifkan";
            $variant = "success";
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: $text,
              variant: $variant,
            },
          });
          // location.href = "/promotions";
          this.getInquiry(this.meta.current_page);
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss" >
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>